module.exports = __webpack_public_path__ + "static/media/calendar.cd18b83b.svg";